import { render, staticRenderFns } from "./ColonCancerScreening.vue?vue&type=template&id=79212bca"
import script from "./ColonCancerScreening.vue?vue&type=script&lang=js"
export * from "./ColonCancerScreening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports